import React, { useMemo } from 'react';

import { SectionItem, SectionType, useFrontmatter } from '~/shared/contexts/frontmatter';

import BackgroundImage from './BackgroundImage';
import Carousel from './Carousel';
import HotIssue from './HotIssue';
import OvensmashBackgroundImage from './OvensmashBackgroundImage';

const sectionMap = {
  'hot-issue': HotIssue,
  carousel: Carousel,
  'background-image': BackgroundImage,
} as const;

const Sections: React.FC = () => {
  const frontmatter = useFrontmatter();
  const sections = frontmatter.sections as unknown as SectionItem[];
  const SectionList = useMemo(
    () =>
      sections
        .map((sectionItem) => {
          const sectionType = sectionItem.type as SectionType;
          const Section =
            frontmatter.gameId === 'ovensmash' && sectionType === 'background-image'
              ? OvensmashBackgroundImage
              : sectionMap[sectionType];
          return [Section, sectionItem] as const;
        })
        .map(([Section, sectionItem]) => (
          // @ts-ignore
          <Section key={sectionItem.id} {...sectionItem} />
        )),
    [frontmatter.gameId, sections],
  );

  return <>{SectionList}</>;
};

export default Sections;
